import React from 'react';
import { getString, removeDefaultParams } from '../../../Utils/helper';
import {
  TextCardActions,
  TextCardAnswer,
} from '../../CommunityPage/TextCard/styled';
import { CardBox, TopicContent, TopicImage } from './styled';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { images } from '../../../Constants/ImageUrls';

function RelatedQuestion(props) {
  const { content, clickedCardEvent } = props;
  const router = useRouter();
  return (
    <Link
      href={{
        pathname: content?.web_url,
        query: removeDefaultParams(router.query),
      }}
      passHref
      locale={false}
      legacyBehavior
    >
      <CardBox
        onClick={() => clickedCardEvent(content?.title, content?.id)}
        as="a"
      >
        {content?.webpImages?.[0] ? (
          <div>
            <TopicImage src={content?.webpImages?.[0]} alt="" />
          </div>
        ) : null}

        <p className="mother_stage">
          {getString(content?.propertytags?.weekPreg)}
        </p>
        <TopicContent>{content?.message}</TopicContent>
        <TextCardActions>
          <TextCardAnswer>
            <span>FOLLOW</span>
          </TextCardAnswer>
          {content?.comments ? (
            <TextCardAnswer>
              <img src={images.comment} alt="" />
              <span>{content?.comments}</span>
              <span>{content?.comments > 1 ? 'Answers' : 'Answer'}</span>
            </TextCardAnswer>
          ) : null}
        </TextCardActions>
      </CardBox>
    </Link>
  );
}

export default RelatedQuestion;
